<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">No Financial Services</h1>

        <section class="content-section">
            <p class="desc-text">XigCheck does not provide:</p>
            <ul class="policy-list">
                <li>financial services</li>
                <li>investment products</li>
                <li>cryptocurrency services</li>
                <li>token exchange services</li>
                <li>securities brokerage</li>
                <li>lending activities</li>
                <li>digital wallet services</li>
            </ul>
            <p class="desc-text">Authentication services are provided solely for marketplace support, product transparency, and user trust purposes.</p>
            <p class="desc-text">No authentication result, marketplace score, reputation indicator, or platform participation metric should be interpreted as financial advice, investment value, income opportunity, or guaranteed economic benefit.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckNoFinancialServices'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
